export default "__VITE_ASSET__Bbme674I__"